// auth action types

export const USER_DATA = "USER_DATA";
export const GET_USER_PROFILE_DATA = "GET_USER_PROFILE_DATA";
export const CHANGE_USER_CURRENCY = "CHANGE_USER_CURRENCY";
export const GET_WORKERS = "GET_WORKERS";
export const GET_AD_POSTS = "GET_AD_POSTS";
export const CLEAR_AD_POSTS = "CLEAR_AD_POSTS";
export const CHANGE_LOGIN_MODAL_DISPLAY = "CHANGE_LOGIN_MODAL_DISPLAY";
export const ADD_NEW_USER_RATE_ID = "ADD_NEW_USER_RATE_ID";
export const GET_ALL_RATED_IDS = "GET_ALL_RATED_IDS";

// cart action types
export const ADD_ARTWORK_IN_CART = "ADD_ARTWORK_IN_CART";

// Global cart action types
export const SET_CART_ITEM_QUANTITY = "SET_CART_ITEM_QUANTITY";
export const UPDATE_CART_ITEM_QUANTITY = "UPDATE_CART_ITEM_QUANTITY";
export const CLEAR_CART = "CLEAR_CART";
export const CLEAR_PRODUCT_CART = "CLEAR_PRODUCT_CART";
export const ADD_CUSTOM_DESIGN = "ADD_CUSTOM_DESIGN";
export const REMOVE_CUSTOM_DESIGN = "REMOVE_CUSTOM_DESIGN";
export const UPDATE_CUSTOM_DESIGN_IMAGE = "UPDATE_CUSTOM_DESIGN_IMAGE";
export const UPDATE_CUSTOM_DESIGN_QUANTITY = "UPDATE_CUSTOM_DESIGN_QUANTITY";
export const SET_CART_OPEN = "SET_CART_OPEN";

export const GET_TRANSACTION_URL = "GET_TRANSACTION_URL";
export const GET_MY_QRS = "GET_MY_QRS";
export const GET_INFO_FOR_FIND_PET = "GET_INFO_FOR_FIND_PET";
export const DELETE_MY_QR = "DELETE_MY_QR";

// QR Code Claim Actions
export const CLAIM_QR_CODE = "CLAIM_QR_CODE";
export const CLAIM_QR_CODE_SUCCESS = "CLAIM_QR_CODE_SUCCESS";
export const CLAIM_QR_CODE_ERROR = "CLAIM_QR_CODE_ERROR";
export const UPDATE_CLAIMED_QR = "UPDATE_CLAIMED_QR";
export const CLEAR_CLAIM_STATE = "CLEAR_CLAIM_STATE";

// Owner Login Actions (for existing QR collars)
export const OWNER_LOGIN = "OWNER_LOGIN";
export const OWNER_LOGIN_SUCCESS = "OWNER_LOGIN_SUCCESS";
export const OWNER_LOGIN_ERROR = "OWNER_LOGIN_ERROR";

// OTP Verification Actions
export const SEND_OTP = "SEND_OTP";
export const SEND_OTP_SUCCESS = "SEND_OTP_SUCCESS";
export const SEND_OTP_ERROR = "SEND_OTP_ERROR";
export const VERIFY_OTP = "VERIFY_OTP";
export const VERIFY_OTP_SUCCESS = "VERIFY_OTP_SUCCESS";
export const VERIFY_OTP_ERROR = "VERIFY_OTP_ERROR";
export const CLEAR_OTP_STATE = "CLEAR_OTP_STATE";
export const OWNER_UPDATE_QR = "OWNER_UPDATE_QR";
export const OWNER_TOGGLE_LOST = "OWNER_TOGGLE_LOST";
export const OWNER_LOGOUT = "OWNER_LOGOUT";

export const SERVER_ERROR = "SERVER_ERROR";
export const CLEAR_ERRORS = "CLEAR_ERRORS";

export const CHANGE_SIGNUP_MODAL_DISPLAY = "CHANGE_SIGNUP_MODAL_DISPLAY";

export const ADD_NEW_POST = "ADD_NEW_POST";
export const GET_POSTS = "GET_POSTS";
export const POSTS_FOR_CONTAINER = "POSTS_FOR_CONTAINER";
export const GET_SINGLE_POST = "GET_SINGLE_POST";
export const DELETE_SINGLE_POST = "DELETE_SINGLE_POST";
export const GET_SAVED_POSTS = "GET_SAVED_POSTS";
export const SAVE_POST = "SAVE_POST";
export const GET_SAVED_POSTS_FOR_FAVORITE_PAGE =
  "GET_SAVED_POSTS_FOR_FAVORITE_PAGE";
export const DELETE_SAVED_POST = "DELETE_SAVED_POST";
export const GET_ACTIVE_POSTS = "GET_ACTIVE_POSTS";
export const GET_CURRANCY_RATE = "GET_CURRANCY_RATE";
export const GET_SINGEL_ACTIVE_POST = "GET_SINGEL_ACTIVE_POST";

// CHAT ACTIONS

export const GET_CHAT_USERS = "GET_CHAT_USERS";
export const GET_CHAT_USER_MESSAGES = "GET_CHAT_USER_MESSAGES";
export const ADD_NEW_CHAT_USER = "ADD_NEW_CHAT_USER";
export const CLEAR_CHAT_USERS = "CLEAR_CHAT_USERS";
export const SEND_MESSAGE = "SEND_MESSAGE";
export const CHANGE_CURRENT_CHAT_USER_ID = "CHANGE_CURRENT_CHAT_USER_ID";

// MANAGEMENT ACTONS
export const GET_BANNERS = "GET_BANNERS";


export const GET_OVERALL_STATISTICS = "GET_OVERALL_STATISTICS";